import { COMPANY_TYPE_TO_LABEL, type CompanyType } from "@/types/companyType"

export const formatVendorType = (types?: string[] | null): string => {
  if (!types?.length) return ""

  return types
    .filter((type): type is string => typeof type === "string" && type.trim() !== "")
    .map((type) => COMPANY_TYPE_TO_LABEL[type as CompanyType] ?? type)
    .join(" / ")
}
